import { getFolderName } from './getFolderName';

export const isInInboxFolder = () => {
    const folderName = getFolderName();
    return folderName === 'inbox';
};
